import { useCallback, useState } from 'react';
import { useField, useForm } from 'react-final-form';

import { Row } from '../../../UIPackage/FormModule/components/Row';
import { TextInputField } from '../../../UIPackage/MainModule/components/TextInputField';
import styles from './PassportGroupConditionNameEditor.module.scss';
import { IPassportGroupForm } from '../interfaces/IPassportGroupForm';

interface IPassportGroupConditionNameEditorProps {
  selectedCondition: string;
}

export const PassportGroupConditionNameEditor = ({ selectedCondition }: IPassportGroupConditionNameEditorProps) => {
  const form = useForm();
  const currentConditionFieldName = `${selectedCondition}.name` as keyof IPassportGroupForm;
  const conditionName = useField('conditionName', { subscription: { value: true } }).input.value;
  const currentConditionName = useField(currentConditionFieldName, { subscription: { value: true } }).input.value;
  const [isNameEditing, setIsNameEditing] = useState(false);

  const handleNameClick = useCallback(() => {
    form.change('conditionName', currentConditionName);
    setIsNameEditing(true);
  }, [form, currentConditionName, setIsNameEditing]);

  const handleNameInputBlur = useCallback(() => {
    form.change(currentConditionFieldName, conditionName);
    setIsNameEditing(false);
  }, [setIsNameEditing, currentConditionFieldName, conditionName]);

  return (
    <Row>
      {isNameEditing ? (
        <TextInputField className={styles.GroupNameInput} onBlur={handleNameInputBlur} name="conditionName" />
      ) : (
        <div className={styles.GroupNameBlock}>
          <div className={styles.GroupName} onClick={handleNameClick}>
            {currentConditionName}
          </div>
          <button className={styles.GroupNameEditButton} onClick={handleNameClick} type="button"></button>
        </div>
      )}
    </Row>
  );
};
